export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

// FORK PATCH (partner-platform): de-branded postMessage prefix.
//
// This string is the host↔iframe handshake. Both ends live in this repo, so it
// is safe to rename — but the two ends are NOT deployed together: sdk.js is
// cached in visitors' browsers on the host page, while the iframe is served
// fresh from us. During a rollout an OLD cached sdk.js will talk to a NEW
// iframe, and vice versa.
//
// So the receiving side accepts BOTH prefixes and the sending side emits only
// the new one. That makes the handshake work in every combination:
//
//   old sdk → new iframe   old prefix sent, new iframe accepts legacy   ✓
//   new sdk → old iframe   new prefix sent, old iframe accepts only
//                          legacy — but an old iframe can only be served
//                          by an old deploy, which pairs with an old sdk    ✓
//
// A mismatch here does not throw; the widget simply never finishes loading,
// which is why the legacy branch is load-bearing rather than defensive tidiness.
//
// DELETE the legacy constant only once no cached sdk.js older than the
// de-branding deploy can still be in circulation.
export const WIDGET_MSG_PREFIX = 'cbx-widget:';
export const LEGACY_WIDGET_MSG_PREFIX = 'chatwoot-widget:';

// Kept as the new value so any straggler import keeps working.
export const WOOT_PREFIX = WIDGET_MSG_PREFIX;
